angular.module('unica_archive_admin.archive_admin_controllers', [])

.controller('ArchiveAdminController', function( $rootScope, $scope, $stateParams, EventSiteService ) {

    $scope.event_id = $stateParams.event_id;

    if ( !$rootScope.year ) {
        $rootScope.year = 2020;
    }

    $rootScope.getEvent( $stateParams.event_id );

    $scope.$on('event_loaded', function() {
        $scope.checkPreviewSite();
    });

    $scope.previewUrl = '#';

    $scope.checkPreviewSite = function() {
        $scope.showLoader();

        EventSiteService
            .checkSitePreview( $stateParams.event_id )
            .then(function(data) {
                $scope.hideLoader();

                if ( data ) {
                    $scope.previewUrl = data.url;
                }
            });
    };

    sessionStorage.setItem('from_admin_archive', true);
});